module.exports = __webpack_public_path__ + "static/scale-model-of-abilene-zoological-park-in-abilene-texas-5003ad19ff9ae08ff9504530397a5216.png";